import { axios } from "../config/axios";
import { ICustomTripWorkingDayPattern, ICustomTripWorkingDayPatternResponse } from "../interfaces/endpoints/patterns/ICustomTripWorkingDayPattern";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { IPagination } from "../interfaces/IPagination";
import { SelectParamsType } from "../interfaces/ISelectParams";
import { serialize } from "../utils/serializeToQueryString";

export const getAllPatterns = async ({
  pageindex,
  pageSize = 10,
  searchKeyword
}: {
  pageindex: number;
  pageSize?: number;
  searchKeyword?: string;
}): Promise<IAxiosResponse<ICustomTripWorkingDayPatternResponse>> => {
  return axios.get<ICustomTripWorkingDayPatternResponse>(
    `v1/CustomTripWorkingDayPattern/patterns/?pageIndex=${pageindex}&pagesize=${pageSize}&searchKeyword=${
      searchKeyword || ""
    }`
  );
};

export const getPatternsSelectList = async ({
  searchKeyword = "",
  ...att
}: SelectParamsType): Promise<IAxiosResponse<IPagination<ICustomTripWorkingDayPattern>>> => {
  const response = await axios.get<ICustomTripWorkingDayPattern[]>(
    `v1/CustomTripWorkingDayPattern/allpatterns${serialize({ ...att, searchKeyword })}`
  );

  return {
    ...response,
    data: {
      result: response.data,
      totalCount: response.data.length,
      pageNumber: 1,
      pageSize: response.data.length,
      totalPages: 1
    }
  };
};

export const getCurrentPattern = async (
  id: number
): Promise<IAxiosResponse<ICustomTripWorkingDayPattern>> => {
  return axios.get<ICustomTripWorkingDayPattern>(`v1/CustomTripWorkingDayPattern/patterns/${id}`);
};

export const upsertPattern = async (
  pattern: ICustomTripWorkingDayPattern
): Promise<IAxiosResponse<number>> => {
  return axios.post("v1/CustomTripWorkingDayPattern/pattern", pattern);
};

export const deletePattern = async (id: number): Promise<boolean> => {
  return axios.delete(`v1/CustomTripWorkingDayPattern/pattern/${id}`);
};
